import CloseIcon from "@mui/icons-material/Close";
import {
  Card,
  CardContent,
  CardHeader,
  Dialog,
  IconButton,
  Table,
  TableCell,
  TableRow,
  Box,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useMessages } from "./MessagesContext";

const MessageLog = () => {
  const [open, setOpen] = useState(false);
  const { selectedMessageLog, selectedMessageLogs, setSelectedMessageLog } =
    useMessages();

  useEffect(() => {
    setOpen(selectedMessageLog !== null);
  }, [selectedMessageLog]);

  const onClose = (e, reason) => {
    setSelectedMessageLog(null);
  };
  return (
    selectedMessageLogs && (
      <Dialog fullWidth maxWidth onClose={onClose} open={open}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
        <Card sx={{ borderRadius: 3 }}>
          <CardHeader
            title={<font className="layer-title"> Message Logs </font>}
            sx={{ pb: 0, paddingLeft: 1, paddingRight: 1 }}
            align="center"
            className={"styledtablerow"}
          />
          <CardContent sx={{ paddingTop: 1, paddingLeft: 0, paddingRight: 0 }}>
            {selectedMessageLogs && (
              <Table size="small">
                <TableRow className="report-header">
                  <TableCell> Message Id </TableCell>
                  <TableCell> Text </TableCell>
                  <TableCell> Start Date </TableCell>
                  <TableCell> Expiration Date </TableCell>
                  <TableCell> Amber Alert </TableCell>
                  <TableCell> Priority </TableCell>
                  <TableCell> User Name </TableCell>
                  <TableCell> Updated Date </TableCell>
                  <TableCell> Updated Type </TableCell>
                </TableRow>
                {selectedMessageLogs.content.map((eachMessageLog, idx) => {
                  return (
                    <TableRow className={idx % 2 === 0 ? "styledtablerow" : ""}>
                      <TableCell> {eachMessageLog.messageId} </TableCell>
                      <TableCell> {eachMessageLog.text} </TableCell>
                      <TableCell> {eachMessageLog.startDate} </TableCell>
                      <TableCell> {eachMessageLog.expirationDate} </TableCell>
                      <TableCell> {eachMessageLog.amberAlert} </TableCell>
                      <TableCell> {eachMessageLog.priority} </TableCell>
                      <TableCell> {eachMessageLog.userName} </TableCell>
                      <TableCell> {eachMessageLog.updateDate} </TableCell>
                      <TableCell> {eachMessageLog.updateType} </TableCell>
                    </TableRow>
                  );
                })}
              </Table>
            )}
            {!selectedMessageLogs && (
              <Box
                sx={{
                  display: "flex",
                  alignContent: "center",
                  alignItems: "center",
                  padding: 10,
                  width: "100%",
                }}
              >
                <CircularProgress sx={{ margin: "auto" }} />
              </Box>
            )}
          </CardContent>
        </Card>
      </Dialog>
    )
  );
};

export default MessageLog;
